/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ProxyControllerProxyGallileoAndEinsteinLab$Params {
}

export function proxyControllerProxyGallileoAndEinsteinLab(http: HttpClient, rootUrl: string, params?: ProxyControllerProxyGallileoAndEinsteinLab$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, proxyControllerProxyGallileoAndEinsteinLab.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

proxyControllerProxyGallileoAndEinsteinLab.PATH = '/proxy/galileoAndEinstein/{url}';
